import type { EmptyResultsCallout } from '@rover/types/src/Callout';

import SearchSectionHeader, {
  HeaderIconEnum,
  HeaderScenariosEnum,
} from '../../SearchSectionHeader';

type EmptyResultsProps = {
  emptyResultCallout: EmptyResultsCallout | undefined;
};

const EmptyResults = ({ emptyResultCallout }: EmptyResultsProps): JSX.Element => {
  return (
    <SearchSectionHeader
      id={HeaderScenariosEnum.NO_RESULTS}
      headerIconName={HeaderIconEnum.EDIT}
      headerText={emptyResultCallout?.data.title ?? ''}
      primarySubheaderText={emptyResultCallout?.data.subtitle ?? ''}
    />
  );
};

export default EmptyResults;
